import { render } from "./ModTerminaContrato.vue?vue&type=template&id=40675e95"
import script from "./ModTerminaContrato.vue?vue&type=script&lang=js"
export * from "./ModTerminaContrato.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__